import { AfterViewInit, Component, Input, OnDestroy, OnInit } from '@angular/core';
import { FormBuilder, FormGroup, ReactiveFormsModule, Validators } from '@angular/forms';
import { Product } from '../shared/model/ui/product';
import { ManagedContentService } from '../shared/service/managed-content.service';
import { FormControlUtilitiesService } from '../shared/service/form-control-utilities.service';
import { CmElement, CmTooltip, ContentType } from '../shared/model/cm/managed-content.model';
import { PrismDropDown } from '../shared/model/prism-dropdown';
import { GlobalConstants } from '../shared/global-constants';
import { fromEvent, Observable, Subscription } from 'rxjs';
import { CUSTOM_ELEMENTS_SCHEMA } from '@angular/core';


@Component({
selector: 'app-life-schedule-salary',
  standalone: true,
  imports: [ReactiveFormsModule],
  templateUrl: './life-schedule-salary.component.html',
  styleUrls: ['./life-schedule-salary.component.scss'],
  providers: [],
  schemas: [CUSTOM_ELEMENTS_SCHEMA],
})
export class LifeScheduleSalaryComponent implements OnInit, OnDestroy, AfterViewInit {
  @Input() parentForm: FormGroup;
  @Input() product: Product;

  resizeObservable$: Observable<Event>;
  resizeSubscription$: Subscription;
  public innerWidth: number = window.innerWidth;
  public multipleOfSalaryTooltipPosition: string = 'top';

  public lifeAmountMultipleElement: CmElement;
  public lifeAmountMultipleToolTip: CmTooltip;
  public lifeAmountMultipleToolTipTitle: string;
  public lifeAmountMultipleToolTipDescription: string;
  public selectText: string = 'Additional Amount';
  public readonly multiplesOfSalary: Array<PrismDropDown> = GlobalConstants.SALARY_MULTIPLES_PRISM;
  public multiplesOfSalaryLabels  = [];

  constructor(private fb: FormBuilder,
    private cmService: ManagedContentService,
    public formControlUtilitiesService: FormControlUtilitiesService
  ) { }

  ngOnInit(): void {

    this.lifeAmountMultipleElement = this.cmService.getContentById(ContentType.ELEMENT, 'life-amount-multiple');
    this.lifeAmountMultipleToolTip = this.cmService.getContentById(ContentType.TOOLTIP, this.lifeAmountMultipleElement.tooltip);
    this.lifeAmountMultipleToolTipTitle = this.lifeAmountMultipleToolTip.title;
    this.lifeAmountMultipleToolTipDescription = this.lifeAmountMultipleToolTip.plainText;
    this.multiplesOfSalaryLabels = [this.selectText].concat(this.multiplesOfSalary.map(salary => salary.viewValue));

    if(this.parentForm){
      // Preserve any existing control value when re-mounting in edit mode.
      const multipleKey = this.product.key + '_multipleOfSalary';
      const existingMultiple = this.parentForm.get(multipleKey);
      if (!existingMultiple) {
        this.parentForm.addControl(multipleKey, this.fb.control('', [Validators.required]));
      } else {
        existingMultiple.setValidators([Validators.required]);
        existingMultiple.updateValueAndValidity({ emitEvent: false });
      }

      if(!this.parentForm.contains(this.product.key + '_schedule')){
        this.parentForm.addControl(this.product.key + '_schedule', this.fb.control('', [Validators.required]));
        this.parentForm.get(this.product.key + '_schedule').setValue('SALARY');
        this.parentForm.updateValueAndValidity();
      } else {
        this.parentForm.get(this.product.key + '_schedule').setValue('SALARY');
        this.parentForm.updateValueAndValidity();
      }
    }

    this.resizeObservable$ = fromEvent(window, 'resize')
    this.resizeSubscription$ = this.resizeObservable$.subscribe( evt => {
      this.innerWidth = window.innerWidth;
      this.changeTooltipPosition();
    });
  }//end ngOnInit

  ngOnDestroy(): void {
    if(this.parentForm){
      this.parentForm.removeControl(this.product.key + '_multipleOfSalary');
      this.parentForm.removeControl(this.product.key + '_schedule');
    }
  }

  ngAfterViewInit(){
    this.innerWidth = window.innerWidth;
    this.changeTooltipPosition();
  }

  changeTooltipPosition(){
    if(this.innerWidth < 750){
      this.multipleOfSalaryTooltipPosition = 'left';
    } else {
      this.multipleOfSalaryTooltipPosition = 'top';
    }
  }

  // Event Handlers
  handleOptionSelected(event: Event, key: string) {

    const customEvent = event as CustomEvent;
    let optSelected = customEvent.detail;
    let optValue = this.getMultOfSalaryValue(optSelected);
    this.parentForm.get(key).setValue(optValue);
  }

  /**
   * Returns the dropdown LABEL ("2 x Annual Earnings") that corresponds to
   * the value currently held by the form control ("2.0"). Used to drive
   * <prism-ui-select [selectedValue]> so the dropdown displays the saved
   * option when the page is loaded in edit mode.
   */
  public getSelectedLabel(): string {
    const formValue = this.parentForm?.get(this.product.key + '_multipleOfSalary')?.value;
    if (formValue === null || formValue === undefined || formValue === '') {
      return '';
    }
    const match = this.multiplesOfSalary.find(opt => opt.value === formValue);
    // Fallback: caller may have stored the label already.
    return match ? match.viewValue : formValue;
  }

  getMultOfSalaryValue(optSelected: string){
    for(let opt of this.multiplesOfSalary){
      if(opt.viewValue === optSelected){
        return opt.value;
      }
    }

    if(optSelected != null && optSelected != undefined && optSelected != ""){
      return this.multiplesOfSalary[0].value;
    } else {
      return null;
    }
  }
}
